const Contact = () => {
  return (
    <div className="bg-blue text-white p-5 flex-grow">
      <h1 className="font-extrabold text-3xl py-5">Contact Us Page</h1>
      <p className="text-justify">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Amet deleniti
        porro dolorum, reiciendis soluta nulla doloribus nam est fugit aliquam?
        Aspernatur ipsa, accusantium ea officiis cumque ad molestias eaque
        expedita. Facilis quisquam consequuntur suscipit veritatis. Nihil
        incidunt fugiat laborum rem, cum dolore officia doloribus aspernatur
        modi accusamus ut laboriosam reprehenderit sit maiores quaerat nobis
        iusto. Itaque ipsum dicta soluta aliquid. Dolor fugiat vero odio dolorum
        ipsum similique amet veritatis iste temporibus totam libero sed,
        incidunt omnis non, id quidem sapiente tempore quisquam eveniet laborum
        sunt voluptas, nostrum maxime? Animi, illum. Molestias rem odio ut nobis
        ducimus, dicta laboriosam exercitationem aspernatur quia accusamus
        perspiciatis unde eaque debitis sed hic explicabo veniam voluptates
        asperiores iure distinctio ad, magni eos harum. Accusantium, voluptates!
        Pariatur maxime tempore exercitationem vitae, accusantium at sed
        quibusdam dolore rem autem. Aspernatur odit temporibus amet consequatur
        placeat enim. Laudantium quasi facere consectetur eos quis vitae nulla
        dignissimos illum ducimus. Iste, blanditiis soluta maxime voluptas sint
        magnam exercitationem quis repellat debitis eveniet architecto nemo
        maiores id aperiam sapiente vel molestias. Omnis quasi dolor,
        accusantium numquam quisquam deleniti autem perferendis ea? Aspernatur,
        odit, ut iste veniam similique explicabo maxime exercitationem qui ea
        cupiditate dignissimos. Exercitationem mollitia minus tempore ut iusto,
        velit veritatis doloremque corporis vitae, quos placeat distinctio
        repudiandae voluptatum officiis. Impedit voluptas nostrum reprehenderit
        sint. Iure, placeat necessitatibus dolores a excepturi libero ex?
        Perferendis et ut facilis ducimus, illo numquam eligendi delectus enim
        ab tenetur magni sit provident similique impedit. Nisi, sequi a.
        Repellendus aperiam a magni repudiandae optio commodi corrupti provident
        iusto qui, iure dolorum voluptatum fugiat cupiditate enim explicabo
        impedit ipsum ipsam est architecto voluptatem? Ipsum, vero cumque.
        Minus, inventore eius rem ipsam modi obcaecati corrupti eos sunt? Minus
        dolor voluptatibus eligendi natus animi nostrum? Eos, voluptatum at
        impedit neque sapiente officia minima a ratione voluptatibus vitae ad.
        Molestias earum optio fuga odit eligendi beatae veritatis provident
        veniam repellat aliquid sed numquam saepe quos illum assumenda
        praesentium facere sequi laboriosam dicta explicabo rem exercitationem,
        fugit incidunt eos! Quam. Sed tenetur eum assumenda corporis optio
        temporibus fugit magnam, incidunt iusto dicta, veniam laborum
        reprehenderit quam consequuntur maiores hic at commodi in ipsa dolores
        neque cumque officia ab est. Repudiandae. Delectus, deleniti ducimus
        doloribus veritatis vel beatae modi, eligendi asperiores quibusdam
        placeat ipsum qui quis. Aperiam, commodi. Dolorem aut placeat in hic,
        incidunt optio? Amet molestiae saepe distinctio odit ut? Totam
        blanditiis est asperiores distinctio minima tempora eius error saepe
        expedita quibusdam quae omnis, aliquid obcaecati odit nulla atque quam
        quod deleniti laudantium. Natus error vitae dolorum doloremque porro
        odio. Fugiat ducimus similique, quos delectus labore distinctio
        architecto repudiandae commodi perspiciatis, voluptatum vero,
        consectetur culpa aliquam ea error dolores sint? Tempore eum delectus
        maiores! Impedit quis aliquam incidunt dolorum quod. Culpa et
        consectetur dolor magni impedit est earum veniam ullam nam ad, cumque
        optio voluptates quaerat mollitia vitae dignissimos aliquid perspiciatis
        incidunt ex voluptatum veritatis delectus omnis nisi? Velit, iure?
        Corporis dolorum, omnis fugiat saepe provident aliquam voluptatum totam
        accusamus, beatae cum animi ratione soluta qui commodi aut. Unde et cum
        quibusdam nihil fugit ipsum quod recusandae delectus repellendus autem?
        Porro, facere sunt veritatis repudiandae temporibus et aspernatur non
        eum ut corrupti! Magni impedit dolorum id cumque est, assumenda
        explicabo hic laboriosam vitae qui, deserunt praesentium dolor.
        Mollitia, distinctio ut? Dolorum excepturi a numquam at, distinctio
        veritatis, placeat corrupti rem voluptates illo aliquam! Sapiente illum
        dolore distinctio esse architecto quae quam, aperiam, enim tempora
        reprehenderit veniam. Id nam et libero? Incidunt tempora rerum facilis
        expedita numquam et minima nulla ex fuga provident possimus sapiente
        soluta aperiam eius suscipit necessitatibus dolorum, culpa saepe
        nesciunt? Aperiam quaerat porro nisi. Facere, assumenda ipsam? Possimus
        voluptates non ea animi aut.
      </p>
    </div>
  );
};

export default Contact;
